module.exports = __webpack_public_path__ + "static/media/baseline-home-24px.5924881c.svg";